type Props = {
  width?: number
  height?: number
}
export const StopSvg = ({ width = 40, height = 40 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM30 22H10V18H30V22Z"
      fill="#F44336"
    />
  </svg>
)
